import { usePrevious } from '@framework/form';
import { useEffect } from 'react';
import { useRuntimeSectionStatusHandler } from './useRuntimeSectionStatusHandler';

export interface IRuntimeSectionStatusMarkerProps {
  sectionId: string;
}

/**
 * Aggiorna lo stato di una sezione in fase di compilazione.
 */
export function RuntimeSectionStatusMarker(
  props: IRuntimeSectionStatusMarkerProps,
) {
  const handler = useRuntimeSectionStatusHandler();

  const prevSectionId = usePrevious(props.sectionId);

  useEffect(() => {
    if (prevSectionId !== props.sectionId) {
      // console.log(`RuntimeSectionStatusMarker for ${props.sectionId}`);
      handler.setOpened(props.sectionId);
    }
  }, [handler, prevSectionId, props.sectionId]);

  return null;
}
